<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
        <li class="breadcrumb-item"><a [routerLink]="newUrl">Visual</a></li>
        <li class="breadcrumb-item active" aria-current="page">Dataset</li>
      </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <p class="fs-5 mb-4 text-center">Dataset Information</p>
    </div>


  <div class="d-flex flex-column align-items-center">
  <div class="card" style="max-width: 50%; width: 100%;" *ngIf="dataset; else noDataset">
    <div class="card-body">
      <!-- Dataset Details -->
      <ul class="list-group mb-3">
        <li class="list-group-item">
          <strong>Display Name:</strong> {{ dataset.displayName }}
        </li>
        <li class="list-group-item">
          <strong>Configured By:</strong> {{ dataset.configuredBy }}
        </li>
        <li class="list-group-item">
          <strong>Created Date:</strong> {{ dataset.createdDate }}
        </li>
        <li class="list-group-item">
          <strong>addRowsAPIEnabled:</strong> {{ dataset.addRowsAPIEnabled }}
        </li>
        <li class="list-group-item">
          <strong>isRefreshable:</strong> {{ dataset.isRefreshable }}
        </li>
        <li class="list-group-item">
          <strong>isEffectiveIdentityRequired:</strong> {{ dataset.isEffectiveIdentityRequired }}
        </li>
        <li class="list-group-item">
          <strong>isEffectiveIdentityRolesRequired:</strong> {{ dataset.isEffectiveIdentityRolesRequired }}
        </li>
        <li class="list-group-item">
          <strong>isOnPremGatewayRequired:</strong> {{ dataset.isOnPremGatewayRequired }}
        </li>
        <li class="list-group-item">
          <strong>targetStorageMode:</strong> {{ dataset.targetStorageMode }}
        </li>
      </ul>

      <!-- Button to go to the dataset -->
      <div class="text-center">
        <a href="{{ dataset.webUrl }}" class="btn btn-primary" target="_blank" rel="noopener">
          <i class="fas fa-external-link-alt"></i> Go to Dataset <i class="bi bi-link"></i>
        </a>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Fallback content if dataset is not available -->
<ng-template #noDataset>
  <div class="alert alert-warning text-center" style="max-width: 600px; margin: 0 auto;">
    No dataset available.
  </div>
</ng-template>
